import React, { useState } from 'react';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Divider, Collapse, Typography, Box } from '@mui/material';
import ExitToAppIcon from '@mui/icons-material/ExitToApp'; // Icon for Logout
import SettingsIcon from '@mui/icons-material/Settings'; // Icon for Settings
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Down Arrow Icon
import ExpandLessIcon from '@mui/icons-material/ExpandLess'; // Up Arrow Icon
import { useLocation, useNavigate } from "react-router-dom";
import topImage from '../../../src/assets/logoWithName.png'
import { logout } from '../../Utils';
import { useSelector } from 'react-redux';
import { useMainMenuList } from './menuConstant';

const MobileMenu = ({ menuOpen, onClose }) => {
    const mainMenuList = useMainMenuList();
    const location = useLocation();
    const navigate = useNavigate()
    const common = useSelector(state => state.common);
    const { userDetails } = common
    const [openSubMenu, setOpenSubMenu] = useState(0)
    const getMenuItemStyle = (isOpen) => {
        return {
            backgroundColor: isOpen ? '#d3d3d369' : 'transparent',
            display: 'flex',
            justifyContent: 'space-between',

        };
    };
    const handleLogout = () => {
        window.location.replace('/logout')
    }
    return (
        <Drawer anchor="left" open={menuOpen} onClose={onClose}>
            <List style={{ width: '77vw', display: 'flex', flexDirection: 'column', height: '100%', overflowY: 'auto', padding: 0 }}>
                <Box
                    style={{
                        borderBottom: '1px solid #d3d3d369',
                        backgroundColor: '#d3d3d369',
                        padding: '10px 0px'
                    }}
                >
                    <img src={topImage} alt="Logo" style={{ width: '70px', height: 'auto' }} />
                    <Typography variant="h6" style={{ fontWeight: 'bold', marginLeft: '10px' }}>
                        {userDetails?.UserName}
                    </Typography>
                    <Typography variant="h6" style={{ marginLeft: '10px', color: 'gray', fontSize: '16px' }}>
                        {userDetails?.BranchName}
                    </Typography>
                </Box>
                <div>
                    {mainMenuList.map((obj, index) => (
                        <>
                            <ListItem key={`Menu-${index}-${obj.id}`} button onClick={() => {
                                if (openSubMenu === obj.id) {
                                    setOpenSubMenu(0)
                                } else {
                                    setOpenSubMenu(obj.id)
                                }
                            }} style={getMenuItemStyle(openSubMenu === obj.id)}>
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <ListItemIcon sx={{ minWidth: '40px' }}>
                                        {obj.icon}
                                    </ListItemIcon>
                                    <ListItemText primary={obj.mainName} />
                                </div>
                                <div>
                                    {openSubMenu === obj.id ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                                </div>
                            </ListItem>
                            {obj.subMenu.filter((col) => col.enable !== false)
                                .map((col, index1) => (
                                    <>
                                        <Collapse key={`SubMenu-${index}-${index1}-${obj.id}`} in={openSubMenu === obj.id} timeout="auto" unmountOnExit>
                                            <Collapse in={openSubMenu === obj.id} timeout="auto" unmountOnExit>
                                                <List component="div" disablePadding>
                                                    <ListItem button onClick={() => {
                                                        if (col?.isNewTabOpen) {
                                                            window.open(col.path, '_blank')
                                                        } else {
                                                            navigate(col.path)
                                                            onClose()
                                                        }

                                                    }} sx={{ paddingY: '6px' }} >
                                                        <ListItemIcon sx={{ minWidth: '40px' }}>
                                                        </ListItemIcon>
                                                        <ListItemText sx={{
                                                            color: col.path === location.pathname ? '#0086ff' : '#000000DE'
                                                        }} primary={col.mainName} />
                                                    </ListItem>
                                                </List>
                                            </Collapse>
                                        </Collapse>
                                    </>
                                ))}

                        </>
                    ))}





                </div>
                <div style={{ flexGrow: 1 }} />
                <Divider />
                <ListItem
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        position: 'sticky',
                        bottom: 0,
                        backgroundColor: '#d3d3d3',
                        zIndex: 10,
                        padding: 0,
                    }}
                    button
                    onClick={onClose}
                >
                    <div style={{ display: 'flex', alignItems: 'center', padding: '8px 16px', flex: 1 }} onClick={handleLogout}>
                        <ListItemIcon>
                            <ExitToAppIcon />
                        </ListItemIcon>
                        <ListItemText primary="Logout" />
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '8px 16px' }}>
                        <Divider orientation="vertical" flexItem style={{ margin: '0 10px' }} />
                        <ListItemIcon sx={{ display: 'flex', justifyContent: "end", minWidth: '30px' }}>
                            <SettingsIcon />
                        </ListItemIcon>
                    </div>
                </ListItem>
            </List>
        </Drawer>
    );
};

export default MobileMenu;
